export const PAGE_HOME_ID = 0;
export const POSITION_STICKY = 'STICKY';
export const POSITION_HIGHLIGHT = 'HIGHLIGHT';
export const POSITION_TIMELINE = 'TIMELINE';
// Usuario generico con el que se comenta y responde "como A3Mil"
export const A3MIL_USER_ID = '99999999';

export const WELLNESS_MENU = {
  id: 1,
  title: 'Objetivo Bienestar'
};
